import React from 'react'
import type { ProductType } from 'apollo-gql'
import { useTranslation } from 'lib/i18n'

import OccasionItems from 'components/OccasionItems/OccasionItems'
import OccasionItemSkeletons from 'components/OccasionItems/OccasionItemSkeletons'
import Typography from 'components/UI/Typography/Typography'
import useRequestOccasions from 'hooks/useRequestOccasions'

import styles from './OccasionsFormItems.module.css'

const NUMBER_OF_OCCASION_ITEMS = 10

type OccasionsFormItemsProps = {
  productType?: ProductType
  hideTitle?: boolean
  hideSubTitle?: boolean
  isMarketingRequest?: boolean
  profileName?: string
}

const OccasionsFormItems = ({
  productType,
  hideTitle = false,
  hideSubTitle = false,
  isMarketingRequest = false,
  profileName,
}: OccasionsFormItemsProps): JSX.Element => {
  const { t } = useTranslation()
  const {
    loading,
    error,
    requestOccasions = [],
  } = useRequestOccasions({
    productType,
    first: 1000,
  })

  if (error) return <div>Error: {JSON.stringify(error, null, 2)}</div> // @todo we can't show this to the user

  return (
    <div data-cy="occasionFormSection">
      {!hideTitle && (
        <div className={styles.titleWrapper}>
          <Typography.H5 theme="primary">
            {t('occasion.title', 'Occasion')}
          </Typography.H5>
        </div>
      )}
      {!hideSubTitle && (
        <div className={styles.subtitleWrapper}>
          <Typography.H6>
            {isMarketingRequest
              ? t(
                  'occasion.subtitleMarketingLabel',
                  'Where will {{profileName}} feature?',
                  {
                    profileName,
                  },
                )
              : t('occasion.subtitle1', 'What’s the occasion?')}
          </Typography.H6>
        </div>
      )}

      {!loading ? (
        <OccasionItems
          occasionsList={requestOccasions}
          limit={NUMBER_OF_OCCASION_ITEMS}
          isMarketingRequest={isMarketingRequest}
        />
      ) : (
        <OccasionItemSkeletons limit={NUMBER_OF_OCCASION_ITEMS} />
      )}
    </div>
  )
}

export default OccasionsFormItems
